// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nDHMJXuTrhEloH {
  min-height: 48px;
  max-height: 48px;
  overflow: hidden;
}
.nDHMJXuTrhEloH.MZyketD35tqMgG {
  min-height: 40px;
  max-height: 40px;
}
@media print {
  .nDHMJXuTrhEloH {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;
  }
}
.r55xLHMhk3aMwk {
  min-height: 70px;
  max-height: 70px;
  overflow: hidden;
}
@media (min-width: 992px) {
  .r55xLHMhk3aMwk {
    min-height: 60px;
    max-height: 60px;
  }
}
`, ""]);
// Exports
export var header = `nDHMJXuTrhEloH`;
export var heightWithoutBottomPadding = `MZyketD35tqMgG`;
export var loggedOutHeader = `r55xLHMhk3aMwk`;
export default ___CSS_LOADER_EXPORT___;
